module.exports = __webpack_public_path__ + "img/16.4748b2c8.png";